import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/en"; // Import English locale

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

export const formatRelativeTime = (dateString: string): string => {
  const date = dayjs(dateString);
  const now = dayjs();

  if (!date.isValid()) {
    return "Invalid Date";
  }

  const diffMinutes = now.diff(date, "minute");
  const diffHours = now.diff(date, "hour");
  const diffDays = now.diff(date, "day");
  const diffYears = now.diff(date, "year");

  if (diffMinutes < 1) {
    return "Just now";
  } else if (diffMinutes < 60) {
    return `${diffMinutes} min ago`;
  } else if (diffHours < 24) {
    return date.format("h:mm A");
  } else if (diffDays === 1) {
    return "Yesterday";
  } else if (diffYears === 0) {
    return date.format("MMM DD");
  } else {
    return date.format("MMM DD, YYYY");
  }
};

export const formatRelativeTimePrecise = (dateString: string): string => {
  const date = dayjs(dateString);
  const now = dayjs();

  if (!date.isValid()) {
    return "Invalid Date";
  }

  const diffMinutes = now.diff(date, "minute");
  const diffHours = now.diff(date, "hour");
  const diffDays = now.diff(date, "day");
  const diffYears = now.diff(date, "year");

  if (diffMinutes < 1) {
    return "Just now";
  } else if (diffMinutes < 60) {
    return `${diffMinutes} min ago`;
  } else if (diffHours < 24) {
    return date.format("h:mm A");
  } else if (diffDays === 1) {
    return `Yesterday [at] ${date.format("h:mm A")}`;
  } else if (diffYears === 0) {
    return date.format("MMM DD [at] h:mm A");
  } else {
    return date.format("MMM DD, YYYY [at] h:mm A");
  }
};

export const formatRelativeTimeShort = (dateString: string): string => {
  const date = dayjs(dateString);
  const now = dayjs();

  if (!date.isValid()) {
    return "Invalid Date";
  }

  const diffMinutes = now.diff(date, "minute");
  const diffHours = now.diff(date, "hour");
  const diffDays = now.diff(date, "day");
  const diffYears = now.diff(date, "year");

  if (diffMinutes < 1) {
    return "Just now";
  } else if (diffMinutes < 60) {
    return `${diffMinutes} min ago`;
  } else if (diffHours < 24) {
    return date.format("h:mm A");
  } else if (diffDays === 1) {
    return `Y'day`;
  } else if (diffYears === 0) {
    return date.format("MMM DD");
  } else {
    return date.format("MMM DD, YYYY");
  }
};
